import { axios } from 'utils/axios';
import {
  PersonalizedProductDetailsApiResponse,
  PersonalizedProductDetailsResponse,
  PersonalProductDetailsInput,
} from './types';

/**
 * Fetches personalized product details including segmentation and price details
 */
export async function getPersonalizedProductDetails(
  input: PersonalProductDetailsInput,
  axiosInstance?: typeof axios
): Promise<PersonalizedProductDetailsResponse> {
  const client = axiosInstance || axios;
  const { product_id, ...others } = input;
  return await client
    .post<PersonalizedProductDetailsApiResponse>(
      `/api/legacy/dux/products/${product_id}`,
      { ...others },
      { isPdexApi: true }
    )
    .then(({ data }) => {
      return {
        ...data.dynamics,
      };
    });
}
